import { useState } from 'react'
import { platform } from '../content.js'
import VideoModal, { PlayIcon } from '../components/VideoModal.jsx'

export default function Platform() {
  const [video, setVideo] = useState(null)
  return (
    <section className="section alt" id="platform">
      <div className="container split">
        <div className="split-text">
          <span className="eyebrow">{platform.eyebrow}</span>
          <h2>{platform.title}</h2>
          <p className="lead">{platform.text}</p>
          <ul className="parts">
            {platform.parts.map((p) => <li key={p.name}><b>{p.name}</b>{p.text}</li>)}
          </ul>
          <p className="platform-closing">{platform.closing}</p>
        </div>
        <div className="platform-media">
          <img className="platform-img" src={`${import.meta.env.BASE_URL}screenshots/${platform.shot}.webp`} alt="The VnuMngr Eco-System: the dashboard feeds the venue website, which pushes content to VenueLista and PromoMngr, and every payment goes directly to the venue's Stripe account" loading="lazy" />
          <button className="platform-play" onClick={() => setVideo(platform.video)} aria-label="Play video: the VnuMngr Eco-System"><PlayIcon /></button>
        </div>
        {video && <VideoModal video={video} onClose={() => setVideo(null)} />}
      </div>
    </section>
  )
}
